export default {
  title: 'Company data',
  document: 'NIE/CIF',
  reason: 'Company name',
  email: 'Email',
  address: 'Address',
  postalCode: 'Postal Code',
  town: 'Town',
  city: 'City',
  country: 'Country',
  inscription: 'Commercial Register inscription',
  accountAssignedId: 'Accounting Account Code',
  irpf: {
    retention: 'IRPF',
    notSupported: 'No IRPF'
  },
  greenPoint: {
    label: 'Green dot fee',
    notSupported: 'Not Supported',
    included: 'included in the amount',
    brokenDown: 'included in the item'
  },
  subjectTo: 'Subject to the special cash basis regime',
  help: 'Company subject to the Special Cash Criteria Regime, in accordance with Art. 23 of Law 14/2013.',
  ticketbaiRequired: 'Notify TicketBAI',
  headingBizkaia: 'Heading',
  headingListBizkaia: 'Download heading list',
  ticketbaiRequiredHelp: 'Norma Foral 13/2021, of 21 April (Álava). Norma Foral 3/2020, of 6 November (Guipúzcoa), Norma Foral 8/2023, of 22 November (Vizcaya).',
  siiRequired: 'Notify SII (LRFE)',
  siiRequiredHelp: `<br>The settlement period for registration in the SII will correspond to the year and month of the invoice accrual date. <br>The date of issue and of registration with the SII shall be the date of issue of the invoice.`,
  modal: {
    text: 'The data have been updated.'
  },
  terms: 'Terms of service',
  version: {
    title: 'Sistema Efactura',
    front: 'Front release: ',
    core: 'Core release: ',
    back: 'API release: '
  },
  verifactu: {
    title: 'VERI*FACTU',
    yesOption: 'Yes',
    noOption: 'No',
    exemptOption: 'Exempt',
    exemptReasonPlaceholder: 'Exemption reason',
    modal: {
      info: 'Once this option is activated, files will be sent immediately after each invoice is issued.\n\nYou will not be able to change this option until January 1st of the following year, as required by law.\n\nIf the original invoice has already been sent from another ERP, communications with the AEAT may be duplicated. Please ensure this before sending the invoice.',
      link: 'More information'
    },
    lockedTooltip: 'You will not be able to change this option until January 1st of the following year',
    rdTooltip: 'Real Decreto 254/2025, de 1 de abril, por el que se modifica el Real Decreto 1007/2023, de 5 de diciembre'
  },
  eReporting: 'E-REPORTING',
  eReportingError: 'You can only select one option from E-REPORTING'
}
